import { Grid } from '@mui/material';
import { PqrTypeParamsDataProps } from './props';
import { usePqrTypeData } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const PqrTypeData = (props: PqrTypeParamsDataProps) => {
    const { formik } = usePqrTypeData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    required
                    errors={formik.errors.name}
                    value={formik.values.name}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="extra"
                    size="small"
                    rows={3}
                    errors={formik.values.extra}
                    value={formik.values.extra}
                />
            </Grid>
        </Grid>
    );
};
